import React from 'react'
import {Button, Row, Table} from 'reactstrap'
import Loader from 'react-loader-spinner'
import {TeamMemberListTableRow} from './'

import SortAscendingIcon from 'react-icons/lib/fa/sort-asc'
import SortDescendingIcon from 'react-icons/lib/fa/sort-desc'
import InviteIcon from 'react-icons/lib/fa/user-plus'
import SaveIcon from 'react-icons/lib/fa/upload'

let sortUsersByName = (users, sortDescending = false) => {
    users = users.sort(function (a, b) {
        const nameA = a.name.toUpperCase()
        const nameB = b.name.toUpperCase()
        return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0
    })
    if (sortDescending) {
        users.reverse()
    }
    return users
}

let getActivePermissions = (user) => {
    return (user.activePermissions && user.activePermissions.permissions ? user.activePermissions.permissions : '')
}

export default class TeamMemberListTable extends React.Component {
    constructor(props) {
        super(props)
        let {users, currentUserID, loading, currentUserIsSupport, onAddUserClicked, onRemoveUserClicked, onSavePermissions} = props
        this.onAddUserClicked = onAddUserClicked
        this.onRemoveUserClicked = onRemoveUserClicked
        this.onSavePermissions = onSavePermissions

        users = sortUsersByName(users)

        this.state = {
            users,
            currentUserID,
            loading,
            currentUserIsSupport,
            sortDescending: false,
            addUserModalVisible: false,
            userConfirmationRequests: []
        }

        this.handleCheckboxChangeForUser = this.handleCheckboxChangeForUser.bind(this)
        this.toggleSortDescending = this.toggleSortDescending.bind(this)
        this.savePermissions = this.savePermissions.bind(this)
    }

    savePermissions() {
        let {users} = this.state
        this.onSavePermissions(users)
    }

    async handleCheckboxChangeForUser(user, permission_name, checked) {
        let {users, sortDescending} = this.state

        user[permission_name] = checked
        users = users.filter(u => u.id !== user.id).concat(user)
        users = sortUsersByName(users, sortDescending)

        this.setState({users})
    }

    toggleSortDescending() {
        let {users, sortDescending} = this.state
        sortDescending = !sortDescending
        users = sortUsersByName(users, sortDescending)
        this.setState({sortDescending, users})
    }

    componentWillReceiveProps(nextProps) {
        let {users, currentUserID, currentUserIsSupport, loading, onAddUserClicked, onRemoveUserClicked, onSavePermissions} = nextProps
        this.onAddUserClicked = onAddUserClicked
        this.onSavePermissions = onSavePermissions
        this.onRemoveUserClicked = onRemoveUserClicked

        let {sortDescending} = this.state

        users = sortUsersByName(users, sortDescending)

        this.setState({
            users,
            currentUserID,
            loading,
            currentUserIsSupport,
        })
    }

    render() {
        let {users, loading, sortDescending, currentUserID, currentUserIsSupport} = this.state

        return <Row className="col-12 mb-2 users-table no-gutters pl-0 pr-0">
            <Table>
                <thead>
                <tr>
                    <th className="d-none d-md-table-cell">
                    </th>
                    <th className="text-center name-table-head" onClick={this.toggleSortDescending}>
                        <small className="font-weight-bold sf-blue">
                            {sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                                <SortAscendingIcon className="sort-asc"/>}
                            Name
                        </small>
                    </th>
                    <th className="text-center pl-0 pr-0">
                        <small className="d-block d-sm-none xs-text">
                            View Cons
                        </small>
                        <small className="d-none d-sm-block d-md-none">
                            View Cons
                        </small>
                        <small className="d-none d-md-block">
                            View Controllers
                        </small>
                    </th>
                    <th className="text-center">
                        <small className="d-block d-sm-none xs-text">
                            View Data
                        </small>
                        <small className="d-none d-sm-block d-md-none">
                            View Data
                        </small>
                        <small className="d-none d-md-block">
                            View Historical Data
                        </small>
                    </th>
                    <th className="text-center">
                        <small className="d-block d-sm-none xs-text">
                            Change Settings
                        </small>
                        <small className="d-none d-sm-block d-md-none">
                            Change Con Settings
                        </small>
                        <small className="d-none d-md-block">
                            Change Controller Settings
                        </small>
                    </th>
                    <th className="text-center">
                        <small className="d-block d-sm-none xs-text">
                            Manage Team
                        </small>
                        <small className="d-none d-sm-block">
                            Manage Team
                        </small>
                    </th>
                    <th>
                    </th>
                </tr>
                </thead>
                {loading ?
                    <tbody>
                    <tr>
                        <td colSpan={100}>
                            <Loader type="TailSpin" color="orange" width={60} height={60}/>
                        </td>
                    </tr>
                    <tr className="invisible">
                        <td className="text-left d-none d-md-table-cell">ico</td>
                        <td>Person Name</td>
                        <td>c</td>
                        <td>c</td>
                        <td>c</td>
                        <td>c</td>
                        <td>del</td>
                    </tr>
                    </tbody> :
                    <tbody>
                        {users.map((user, idx) =>
                            <TeamMemberListTableRow user={user}
                                                       currentUserID={currentUserID}
                                                       currentUserIsSupport={currentUserIsSupport}
                                                       onRemoveUserClicked={this.onRemoveUserClicked}
                                                       onCheckboxChangeForUser={this.handleCheckboxChangeForUser}
                                                       key={`${user.id}-${getActivePermissions(user)}-${user.name}-${idx}`}/>)}
                    </tbody>}
            </Table>

            <div className="row col-12 m-2 justify-content-center justify-content-sm-between pl-1 pr-4">
                <Button className="bg-light-sf-blue"
                        onClick={this.onAddUserClicked}>
                    <InviteIcon className="mr-2"/>Invite User
                </Button>
                <Button className="bg-success ml-2"
                        onClick={this.savePermissions}>
                    <SaveIcon className="mr-2"/>Save Permissions
                </Button>
            </div>
        </Row>
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/TeamMemberListTable.js